import { render, staticRenderFns } from "./WombatFooter.vue?vue&type=template&id=328cbf5c&scoped=true"
import script from "./WombatFooter.vue?vue&type=script&lang=js"
export * from "./WombatFooter.vue?vue&type=script&lang=js"
import style0 from "./WombatFooter.vue?vue&type=style&index=0&id=328cbf5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328cbf5c",
  null
  
)

export default component.exports